import { TSchemaBuilder } from "@pages/ManualDocumentV2/core";
import * as Yup from "yup";
import {
  customerSchema,
  documentInfoSchema,
  itemsSchema,
  recurringSchema,
  taxesSchema,
  totalsSchema,
  uploadSchema,
  vendorSchema,
} from "../../../_shared/schemaHelpers";

export const verifactuSimplifiedInvoiceSchema: TSchemaBuilder = (t) =>
  documentInfoSchema({
    t,
    documentClass: "Invoice",
    poErrorKey: "poNumber_is_required",
    dueDateRequired: true,
    enforceDateOrder: true,
  })
    .concat(
      customerSchema(t, {
        omit: [
          "customerCompanyID",
          "customerCountry",
          "customerCompanyStreet",
          "customerCompanyStreetNumber",
          "customerCompanyLocality",
          "customerCompanyRegion",
          "customerCompanyZipCode",
        ],
      }),
    )
    .concat(vendorSchema(t))
    .concat(itemsSchema(t))
    .concat(taxesSchema(t))
    .concat(totalsSchema(t))
    .concat(uploadSchema())
    .concat(recurringSchema()) as Yup.ObjectSchema<any>;